import React from "react";
import emp from "../../images/services/emp.png";
import air from "../../images/services/air.png";
import eve from "../../images/services/eve.png";
import out from "../../images/services/out.png";
import { Fade } from "react-awesome-reveal";

const Services = () => {
  const services = [
    {
      title: "Employee Transportation",
      desc: "Ensure your teams commute safely and comfortably with daily pick-up and drop services tailored for IT parks, BPOs, and business hubs.",
      img: emp,
    },
    {
      title: "Airport Transfers",
      desc: "On-time, reliable airport transfers for your executives, ensuring stress-free travel experiences for arrivals and departures.",
      img: air,
    },
    {
      title: "Event & Conference Transport",
      desc: "Fleet solutions for corporate events, summits, and seminars — perfectly coordinated and professionally managed.",
      img: eve,
    },
    {
      title: "Outstation Business Trips",
      desc: "From client meetings to corporate visits, our chauffeur-driven cars make long-distance travel smooth and productive.",
      img: out,
    },
  ];

  return (
    <Fade delay={1e2} cascade damping={1e-1}>
      <section
        id="services"
        className="max-w-8xl  md:px-[50px] lg:px-[120px] md:mx-auto bg-white py-16  mx-4"
      >
        {/* Section Header */}
        <div className="text-center max-w-5xl mx-auto mb-12">
          <p className="text-sm text-gray-500 mb-2 md:mb-0 md:h-[26px]">
            Services
          </p>
          <h2 className="text-2xl text-center content-center md:text-4xl  md:h-[62px] font-bold text-gray-900 mb-6">
            Choose the Right Car for Your Business
          </h2>
          <p className="md:max-w-[995px] text-gray-600 font-medium leading-relaxed text-sm md:text-[18px]">
            At Carzen Logistics, we provide reliable and professional corporate
            car rental solutions across India. From airport transfers to
            employee mobility, our chauffeur-driven fleet ensures smooth, safe,
            and on-time travel for every business need — backed by 24/7 support
            and premium service.
          </p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg group"
            >
              <Fade direction="up" triggerOnce ascade damping={0.2}>
                <img
                  src={service.img}
                  alt={service.title}
                  className="w-full h-64 md:h-[335px] object-cover transition-transform duration-500 group-hover:scale-105"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                {/* Text */}
                <div className="absolute bottom-0 p-6 text-white text-center">
                  <h3 className="text-[16px] md:text-[18px] font-semibold mb-2 md:h-[31px]">
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-[16px]  text-gray-200">
                    {service.desc}
                  </p>
                </div>
              </Fade>
            </div>
          ))}
        </div>
      </section>
    </Fade>
  );
};

export default Services;
